// GENERATED by scripts/build-themes.mjs (pnpm themes:build) — do not edit.
// Mirrors specs/design-system/themes/*.theme.json.

export const THEME_IDS = ["electronics", "geist", "home-goods", "medusa", "sneakers", "supplements", "womens-fashion"] as const
export const THEME_MODES = ["light", "dark"] as const

export type ThemeId = (typeof THEME_IDS)[number]
export type ThemeMode = (typeof THEME_MODES)[number]

/** Plain-language names for the settings panel; ids never reach the screen. */
export const THEME_LABELS: Record<string, string> = {
  default: "Medusa default",
  "electronics": "Ferrite",
  "geist": "Geist",
  "home-goods": "Long Morning",
  "medusa": "Medusa default",
  "sneakers": "Kerbstone",
  "supplements": "Scruple",
  "womens-fashion": "Larchant",
}

/** Canon tokens written per preset per mode; the panel's source line quotes it. */
export const THEME_TOKEN_COUNT = 31
